export default "__VITE_ASSET__Qqr6qOgT__"